// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Gfy1qg","rootActive":"_2r2KnLI","rootFocus":"_16pm_at","root_isPink":"_3GItr7v","rootHover":"_3sGx50s","root_isBlue":"_32FiEvS","root_isGray":"_1CabKG2","loading":"_1LQMgGp"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/Button/Button.less
 ** module id = 633
 ** module chunks = 0
 **/